
import { convertToSlug } from '~/helpers/generate-slug'

export default {
  props: {
    product: {
      default: () => {},
    },
  },
  methods: {
    convertToSlug,
  },
}
